var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 13.3333L4.66699 13.3333",
    stroke: "#7D7D7D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11.3333H10.667",
    stroke: "#7D7D7D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6H2.66667C2.29848 6 2 6.29848 2 6.66667V10.6667C2 11.0349 2.29848 11.3333 2.66667 11.3333H8.66667",
    stroke: "#7D7D7D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 4.66669H11.3343V4.66802H11.333V4.66669Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 2.66669H9.33366C8.96547 2.66669 8.66699 2.96516 8.66699 3.33335V12.6667C8.66699 13.0349 8.96547 13.3334 9.33366 13.3334H13.3337C13.7018 13.3334 14.0003 13.0349 14.0003 12.6667V3.33335C14.0003 2.96516 13.7018 2.66669 13.3337 2.66669Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDevices;